var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6C4.72385 6 4.5 6.22385 4.5 6.5C4.5 6.77615 4.72385 7 5 7H7C7.27612 7 7.5 6.77615 7.5 6.5C7.5 6.22385 7.27612 6 7 6H5Z",
    fill: "#9B9DA3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C1.17157 1 0.5 1.67157 0.5 2.5V9.5C0.5 10.3284 1.17157 11 2 11H10C10.8284 11 11.5 10.3284 11.5 9.5V2.5C11.5 1.67157 10.8284 1 10 1H2ZM10 2H2C1.72385 2 1.5 2.22385 1.5 2.5V4H10.5V2.5C10.5 2.22385 10.2761 2 10 2ZM1.5 9.5V5H10.5V9.5C10.5 9.77615 10.2761 10 10 10H2C1.72385 10 1.5 9.77615 1.5 9.5Z",
    fill: "#9B9DA3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.b5a812a9cecedc419895c0d066731eb1.svg";
export { ForwardRef as ReactComponent };